import { makeApiRequest } from 'actions/api';
import RequestService from 'services/RequestService';

export const GET_REACTIVATION = 'GET_REACTIVATION';
export const GET_REACTIVATION_REQUEST = 'GET_REACTIVATION_REQUEST';
export const GET_REACTIVATION_RESPONSE = 'GET_REACTIVATION_RESPONSE';
export const GET_REACTIVATION_ERROR = 'GET_REACTIVATION_ERROR';

export const getRestartCampaign = () =>
  makeApiRequest({ requestType: GET_REACTIVATION, method: RequestService.getRestartCampaign });
